import assign from 'lodash.assign';

const { createHigherOrderComponent } = wp.compose;
const { Fragment, useState } = wp.element;
const { InspectorControls } = wp.editor;
const { PanelBody, SelectControl, TextControl, ToggleControl, RangeControl, Flex, FlexBlock, ColorPicker, FlexItem } = wp.components;
const { addFilter } = wp.hooks;
const { __ } = wp.i18n;


wp.blocks.registerBlockVariation('core/paragraph', {
    name: "circle-counter",
    title: 'Circle Counter',
    keywords: [ "counter", "number", "count" ],
    icon: 'image-rotate',
    isDefault: false,
    category: "text",
    scope: [ "inserter", "transform", "block" ],
    description: "Circle Counter Animation",
    attributes: { className: "is-circle-sp-counter", dataStart: 100, dataEnd: 300, prefix: '' },
    isActive: (e) => {
        if (e.className && e.className.includes('is-circle-sp-counter')) {
            return true;
        }
        return false;
    },

});


// Enable spacing control on the following blocks
const enableCounterControlOnBlocks = [
    'core/paragraph',
];
/*eslint space-in-parens: ["error", "always"]*/


/**
 * Add spacing control attribute to block.
 *
 * @param {object} settings Current block settings.
 * @param {string} name Name of block.
 *
 * @returns {object} Modified block settings.
 */
const addDataStartEndControlAttribute = (settings, name) => {
    // Do nothing if it's another block than our defined ones.
    if (!enableCounterControlOnBlocks.includes(name)) {
        return settings;
    }


    // Use Lodash's assign to gracefully handle if attributes are undefined
    settings.attributes = assign(settings.attributes, {

        percent: {
            type: 'string',
            default: 10
        },
        size: {
            type: 'string',
            default: 110
        },
        linewidth: {
            type: 'string',
            default: 15
        },
        cap: {
            type: 'string',
            default: 'round'
        },
        barcolor: {
            type: 'string',
            default: 'round'
        },
        scalecolor: {
            type: 'string',
            default: ''
        },
        trackcolor: {
            type: 'string',
            default: ''
        }
    });

    return settings;
};

addFilter('blocks.registerBlockType', 'extend-block-example/circle-couter/data', addDataStartEndControlAttribute);







/**
 * Create HOC to add spacing control to inspector controls of block.
 */
const withSpacingControl = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        const { setAttributes } = props;

        // Do nothing if it's another block than our defined ones.
        if (!enableCounterControlOnBlocks.includes(props.name)) {
            return (
                <BlockEdit { ...props } />
            );
        }
        if (!(props.attributes.className && props.attributes.className.includes('is-circle-sp-counter'))) {
            return (
                <BlockEdit { ...props } />
            )
        }

        function initPieChart () {
            jQuery('.sp-chart').easyPieChart({
                size: 100,
                animate: 2000,
                lineWidth: 26,
                lineCap: 'butt',
                scaleColor: false,
                barColor: '#d35400',
                trackColor: '#7f8c8d',
            });
        }
        initPieChart();


        return (
            <Fragment>


                <div class="is-circle-sp-counter">
                    <BlockEdit { ...props } />
                    <span class="sp-chart"
                        data-percent={ props.attributes.percent }
                        data-size={ props.attributes.size }
                        data-line-cap={ props.attributes.cap }
                        data-bar-color={ props.attributes.barcolor }
                        data-line-width={ props.attributes.linewidth }
                        data-scale-color={ props.attributes.scalecolor }
                        data-bar-color={ props.attributes.barcolor }
                        data-track-color={ props.attributes.trackcolor }
                    >
                        <span class="sp-percent">{ props.attributes.percent }</span>
                    </span>
                </div>



                <InspectorControls>
                    <PanelBody
                        title={ __('Counter Settings') }
                        initialOpen={ true }
                    >

                        <Fragment>
                            <Flex>
                                <FlexBlock>
                                    <TextControl
                                        type="number"
                                        label={ __("Counter(%)", 'sparkle-blocks') }
                                        min={ 1 }
                                        max={ 100 }
                                        step={ 1 }
                                        className="counter-start"
                                        placeholder="Value"
                                        value={ props.attributes.percent }
                                        onChange={ (val) => setAttributes({ percent: val, content: val }) }
                                    />
                                </FlexBlock>
                                <FlexBlock>
                                    <TextControl
                                        type="number"
                                        label={ __("Size", 'sparkle-blocks') }
                                        min={ 50 }
                                        max={ 800 }
                                        step={ 5 }
                                        placeholder="Size"
                                        value={ props.attributes.size }
                                        onChange={ (val) => setAttributes({ size: val }) }
                                    />
                                </FlexBlock>

                                <FlexBlock>

                                    <TextControl
                                        type="number"
                                        label={ __("Line Width", 'sparkle-blocks') }
                                        min={ 5 }
                                        max={ 100 }
                                        step={ 1 }
                                        placeholder="Width"
                                        value={ props.attributes.linewidth }
                                        onChange={ (val) => setAttributes({ linewidth: val }) }
                                    />
                                </FlexBlock>

                            </Flex>

                            <SelectControl
                                label={ __('Cap') }
                                value={ props.attributes.cap }
                                options={ [
                                    {
                                        label: __('Butt'),
                                        value: 'butt',
                                    },
                                    {
                                        label: __('Round'),
                                        value: 'round',
                                    },
                                    {
                                        label: __('Square'),
                                        value: 'square',
                                    }
                                ] }
                                onChange={ (val) => {
                                    props.setAttributes({
                                        cap: val,
                                    });
                                } }
                            />

                            <PanelBody
                                title={ __('Bar Color Settings') }
                                initialOpen={ false }
                            >
                                <ColorPicker
                                    label={ __("Bar Color", 'sparkle-blocks') }
                                    color={ props.attributes.barcolor }
                                    onChange={ (val) => setAttributes({ barcolor: val }) }
                                    enableAlpha
                                />
                            </PanelBody>
                            <PanelBody
                                title={ __('Scale Color Settings') }
                                initialOpen={ false }
                            >

                                <ColorPicker
                                    label={ __("Scale Color", 'sparkle-blocks') }
                                    color={ props.attributes.scalecolor }
                                    onChange={ (val) => setAttributes({ scalecolor: val }) }
                                    enableAlpha
                                />
                            </PanelBody>
                            <PanelBody
                                title={ __('Track Color Settings') }
                                initialOpen={ false }
                            >
                                <ColorPicker
                                    label={ __("Track Color", 'sparkle-blocks') }
                                    color={ props.attributes.trackcolor }
                                    onChange={ (val) => setAttributes({ trackcolor: val }) }
                                    enableAlpha
                                />

                            </PanelBody>
                        </Fragment>


                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    };
}, 'withSpacingControl');

addFilter('editor.BlockEdit', 'extend-block-example/with-circle-counter-control', withSpacingControl);